/** Standard API JSON body when HTTP status is 200. */
export interface ApiEnvelope {
  error?: boolean;
  message?: string;
  data?: unknown;
}

export function hasApiEnvelope(data: unknown): data is ApiEnvelope & { error: boolean } {
  return (
    data !== null &&
    typeof data === 'object' &&
    typeof (data as ApiEnvelope).error === 'boolean'
  );
}

export function envelopeMessage(data: ApiEnvelope, fallback: string): string {
  return typeof data.message === 'string' && data.message.trim()
    ? data.message.trim()
    : fallback;
}
